import moment from 'moment';
import Select from 'react-select';
//import _debounce from 'lodash/debounce';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from 'react-bootstrap';
import './LopAndOvertimeRequestFormModel.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';

import {
  useGetLopOvertimeRequestQuery,
  useAddLopOvertimeRequestMutation,
  useEditLopOvertimeRequestMutation
} from '../../../../redux/apis/LOPAndOvertimeAPI';
import {
  setState,
  selectedLopOvertimeRequest
} from '../../../../redux/Slice/lopOvertimeRequestSlice';
import { useIsLoggedInQuery } from '../../../../redux/apis/authApi';
import { useGetEmployeeDropDownQuery } from '../../../../redux/apis/employee';

import SingleSelectBox from '../../../../components/UI/SingleSelectBox';

import {
  skipRow,
  handleApiError,
  getErrorMessage,
  mergeAndRemoveDeduplicate
} from '../../../../utils/handler';
import { notification } from '../../../../utils/notification';
import { TOAST_TYPE } from '../../../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import { lOPOvertimeRequestFormSchema } from '../../../../utils/schemas/payrun';
import { INPUT_LABEL, PLACEHOLDER } from '../../../../utils/constant/placeHolders';
import {
  GLOBAL,
  LOP_OVERTIME_TYPE,
  PAYROLL_CATEGORY,
  ROLES
} from '../../../../utils/constant/global';

const {
  LB_USER,
  LB_LOP_OVERTIME_TYPE,
  LB_LOP_OVERTIME_DAYS,
  LB_LOP_OVERTIME_REASON,
  LB_LOP_OVERTIME_CLAIM_DATE
} = INPUT_LABEL;

const { ADMIN, HR } = ROLES;
const { DESC, ASC } = GLOBAL;
const { BTN_SAVE, BTN_CANCEL } = BT_BUTTON_LABELS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { PH_LOP_OVERTIME_REASON, PH_LOP_OVERTIME_DAYS } = PLACEHOLDER;

const LopAndOvertimeRequestFormModel = () => {
  const dispatch = useDispatch();
  const lopOvertimeState = useSelector((state) => state.lopOvertimeRequest);

  const { data: isLogin } = useIsLoggedInQuery();

  const { refetch: lopOvertimeRequestFetch } = useGetLopOvertimeRequestQuery({
    search: lopOvertimeState?.search || '',
    skip: skipRow(lopOvertimeState?.currentPage, lopOvertimeState?.rowsPerPage),
    limit: lopOvertimeState?.rowsPerPage,
    sort: lopOvertimeState?.sortField,
    sortType: lopOvertimeState.sortDirection ? DESC : ASC
  });

  const { data: dropdownData, refetch: employeeDropDownQuery } = useGetEmployeeDropDownQuery({
    skip: skipRow(lopOvertimeState?.currentPageDropdown, lopOvertimeState?.rowsPerPageDropdown),
    limit: lopOvertimeState?.rowsPerPageDropdown
  });

  const [addLopOvertimeRequest] = useAddLopOvertimeRequestMutation();
  const [editLopOvertimeRequest] = useEditLopOvertimeRequestMutation();

  useEffect(() => {
    // Update dropdownData
    if (dropdownData && Array.isArray(dropdownData.data)) {
      const uniqueData = mergeAndRemoveDeduplicate(
        lopOvertimeState.dropdownDataStore,
        dropdownData.data,
        '_id'
      );

      dispatch(
        setState({
          ...lopOvertimeState,
          dropdownDataStore: uniqueData
        })
      );
    }
  }, [dropdownData]);

  useEffect(() => {
    handleSetEditFormData();
  }, [lopOvertimeState.selectedLopOvertimeRequestData]);

  useEffect(() => {
    if (lopOvertimeState?.isModal?.model) {
      employeeDropDownQuery();
    }
  }, [lopOvertimeState?.isModal?.model]);

  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(lOPOvertimeRequestFormSchema),
    values: {
      requestType:
        lopOvertimeState.selectedLopOvertimeRequestData?.requestType || PAYROLL_CATEGORY.LOP,
      claimDate: lopOvertimeState.selectedLopOvertimeRequestData?.claimDate
        ? moment(Number(lopOvertimeState.selectedLopOvertimeRequestData.claimDate)).format(
            'YYYY-MM-DD'
          )
        : moment().format('YYYY-MM-DD'),
      userId: lopOvertimeState.selectedLopOvertimeRequestData?.user?._id || ''
    }
  });

  const valuesData = watch();

  const handleSetEditFormData = () => {
    if (lopOvertimeState.selectedLopOvertimeRequestData) {
      setValue('days', lopOvertimeState.selectedLopOvertimeRequestData?.days || '');
      setValue('reason', lopOvertimeState.selectedLopOvertimeRequestData?.reason || '');
      setValue('requestType', lopOvertimeState.selectedLopOvertimeRequestData?.requestType || '');
      setValue(
        'claimDate',
        lopOvertimeState.selectedLopOvertimeRequestData?.claimDate
          ? moment(Number(lopOvertimeState.selectedLopOvertimeRequestData.claimDate)).format(
              'YYYY-MM-DD'
            )
          : moment().format('YYYY-MM-DD')
      );
      setValue('userId', lopOvertimeState.selectedLopOvertimeRequestData.user?._id || '');
    }
  };

  const handleMenuScrollToBottom = async () => {
    if (dropdownData.isNext) {
      dispatch(
        setState({
          ...lopOvertimeState,
          currentPageDropdown: lopOvertimeState.currentPageDropdown + 1
        })
      );
      await employeeDropDownQuery();
    }
  };

  const handleEditLOPAndOvertime = async (data, id) => {
    try {
      const editData = {
        data,
        id
      };

      dispatch(setState({ ...lopOvertimeState, loading: true }));

      // Call editLopOvertimeRequest and handle the response
      const { data: resData, error } = await editLopOvertimeRequest(editData);

      if (resData?.success) {
        notification(resData.statusMessage, TOAST_SUCCESS);
        handleResetState();
      } else if (error) {
        handleApiError(error);
        handleResetState();
      }
      lopOvertimeRequestFetch();
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
      handleResetState();
    }
  };

  const handleResetState = () => {
    reset();
    dispatch(selectedLopOvertimeRequest(null));
    dispatch(
      setState({
        ...lopOvertimeState,
        isModal: { model: false, submit: false },
        loading: false,
        modalHeader: { title: '', isEdit: false, editId: '' }
      })
    );
  };

  const handleAddLOPAndOvertime = async (data) => {
    try {
      // Update lopOvertimeState to indicate loading lopOvertimeState
      dispatch(
        setState({
          ...lopOvertimeState,
          loading: true
        })
      );

      // Perform the API call to add the KPI data (assuming addLeaveType is your API function)
      const { data: resData, error } = await addLopOvertimeRequest(data);

      if (resData?.success) {
        notification(resData.statusMessage, TOAST_SUCCESS);
        handleResetState();
      } else if (error) {
        handleApiError(error);
        handleResetState();
      }
      lopOvertimeRequestFetch();
    } catch (error) {
      notification(error?.data?.data?.message, TOAST_ERROR);
      handleResetState();
    }
  };

  const onSubmit = (data) => {
    const userId = data.userId || (isLogin && isLogin.data && isLogin.data._id);
    const requestData = {
      ...data,
      days: data?.days ? Number(data.days) : 0,
      userId,
      claimDate: data?.claimDate ? moment(data.claimDate).valueOf() : null
    };

    // Update lopOvertimeState to show modal and indicate submission in progress
    dispatch(
      setState({
        ...lopOvertimeState,
        isModal: { model: true, submit: true }
      })
    );

    // Determine whether to edit existing data or add new data
    if (lopOvertimeState.selectedLopOvertimeRequestData?._id) {
      // Call edit function if editing existing data
      handleEditLOPAndOvertime(requestData, lopOvertimeState.selectedLopOvertimeRequestData._id);
    } else {
      // Call add function if adding new data
      handleAddLOPAndOvertime(requestData);
    }
  };

  const handleDialogCancel = () => {
    dispatch(setState({ ...lopOvertimeState, isModal: { model: false, submit: false } }));
  };

  const onDayHandleChange = (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d*$/;
    // Check if the value matches the regex
    if (regex.test(value)) {
      // Update the value if it's valid
      setValue('days', value, { shouldValidate: true });
    } else {
      // Optionally, you can clear the input or set an empty string
      e.target.value = watch('days'); // Revert the input to the last valid value
    }
  };

  return (
    <Modal
      centered
      className="lop-modal"
      dialogClassName="lop-modal__dialog"
      contentClassName="lop-modal__content"
      show={lopOvertimeState?.isModal?.model}
      onHide={() => {
        reset();
        dispatch(setState({ ...lopOvertimeState, isModal: { model: false, submit: false } }));
      }}
    >
      <Modal.Header className="lop-modal__header">
        <div className="lop-modal__header-content">
          <span className="lop-modal__header-icon" aria-hidden="true">
            <i className="icofont-clock-time" />
          </span>
          <div className="lop-modal__header-copy">
            <Modal.Title className="fw-bold lop-modal__title">
              {lopOvertimeState?.modalHeader?.title}
            </Modal.Title>
            <p className="lop-modal__subtitle">
              {lopOvertimeState?.modalHeader?.isEdit
                ? 'Update this LOP or overtime request'
                : 'Enter the LOP or overtime details'}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close lop-modal__close"
          aria-label="Close"
          onClick={() => {
            reset();
            dispatch(setState({ ...lopOvertimeState, isModal: { model: false, submit: false } }));
          }}
        />
      </Modal.Header>
      <form className="lop-modal__form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="lop-modal__body">
          <div className="lop-modal__section">
            {[ADMIN, HR].includes(isLogin?.data?.hrxRole?.roleName) && (
              <div className="lop-modal__field">
                <label className="lop-modal__label">{LB_USER}</label>
                <Select
                  className="lop-modal__select"
                  classNamePrefix="lop-modal-select"
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 100000 }) }}
                  options={lopOvertimeState.dropdownDataStore?.map((val) => ({
                    value: val._id,
                    label: val.name
                  }))}
                  onChange={(selectedOption) => {
                    setValue('userId', selectedOption.value);
                  }}
                  defaultValue={{
                    value: lopOvertimeState.selectedLopOvertimeRequestData?.user?._id,
                    label: lopOvertimeState.selectedLopOvertimeRequestData?.user?.name
                  }}
                  onMenuScrollToBottom={handleMenuScrollToBottom}
                  placeholder="Select option..."
                  isDisabled={lopOvertimeState.isEditModalData?.user?._id}
                />
                <small className="text-danger lop-modal__error">
                  {getErrorMessage('userId', errors)}
                </small>
              </div>
            )}

            <div className="lop-modal__field">
              <label className="lop-modal__label">{LB_LOP_OVERTIME_TYPE}</label>
              <div className="lop-modal__native-select">
                <SingleSelectBox
                  handleSelectedData={(val) => {
                    setValue('requestType', val);
                  }}
                  value={valuesData?.requestType || ''}
                  options={LOP_OVERTIME_TYPE}
                  error={getErrorMessage('requestType', errors)}
                />
              </div>
            </div>

            <div className="lop-modal__grid">
              <div className="lop-modal__field">
                <label htmlFor="datepickerdedass" className="lop-modal__label">
                  {LB_LOP_OVERTIME_CLAIM_DATE}
                </label>
                <input
                  type="date"
                  className="form-control lop-modal__input"
                  id="datepickerdedass"
                  value={
                    valuesData?.claimDate
                      ? moment(valuesData.claimDate).format('YYYY-MM-DD')
                      : moment().format('YYYY-MM-DD')
                  }
                  onChange={(e) => {
                    setValue('claimDate', e.target.value);
                  }}
                />
                <small className="text-danger lop-modal__error">
                  {getErrorMessage('claimDate', errors)}
                </small>
              </div>
              <div className="lop-modal__field">
                <label htmlFor="lop-overtime-days" className="lop-modal__label">
                  {LB_LOP_OVERTIME_DAYS}
                </label>
                <input
                  id="lop-overtime-days"
                  type="string"
                  {...register('days')}
                  className="form-control lop-modal__input"
                  placeholder={PH_LOP_OVERTIME_DAYS}
                  onChange={onDayHandleChange}
                />
                <small className="text-danger lop-modal__error">
                  {getErrorMessage('days', errors)}
                </small>
              </div>
            </div>

            <div className="lop-modal__field">
              <label htmlFor="lop-overtime-reason" className="lop-modal__label">
                {LB_LOP_OVERTIME_REASON}
              </label>
              <textarea
                id="lop-overtime-reason"
                {...register('reason')}
                placeholder={PH_LOP_OVERTIME_REASON}
                className="form-control lop-modal__textarea"
              />
              <small className="text-danger lop-modal__error">
                {getErrorMessage('reason', errors)}
              </small>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="lop-modal__footer">
          <button type="button" className="btn lop-modal__cancel" onClick={handleDialogCancel}>
            {BTN_CANCEL}
          </button>
          <button
            type="submit"
            disabled={lopOvertimeState?.loading || false}
            className="btn lop-modal__submit"
          >
            {lopOvertimeState?.loading ? (
              <div className="spinner-border spinner-border-sm" role="status"></div>
            ) : (
              <>
                <i className="icofont-check-circled" aria-hidden="true" />
                {BTN_SAVE}
              </>
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default LopAndOvertimeRequestFormModel;
